const LABEL_GAP = 58;

function spreadLabels(labels, height) {
    const sorted = [...labels].sort((a, b) => a.targetY - b.targetY);
    sorted.forEach((label, index) => {
        label.y = Math.max(label.targetY, index ? sorted[index - 1].y + LABEL_GAP : 32);
    });
    const overflow = (sorted.at(-1)?.y || 0) - (height - 32);
    if (overflow > 0) sorted.forEach(label => { label.y -= overflow; });
    return sorted;
}

export function productPieLayout(rows, width) {
    const total = rows.reduce((sum, row) => sum + row.totalCount, 0);
    const radius = Math.min(145, Math.max(44, width * 0.16));
    const cx = width / 2;
    let consumed = 0;
    const labels = rows.map((row, index) => {
        const share = row.totalCount / total;
        const angle = (90 - (consumed + share / 2) * 360) * Math.PI / 180;
        consumed += share;
        return {index, share, angle, right: Math.cos(angle) >= 0};
    });
    const largestSide = Math.max(labels.filter(label => label.right).length, labels.filter(label => !label.right).length);
    const height = Math.max(420, (largestSide - 1) * LABEL_GAP + 72);
    const cy = height / 2;
    labels.forEach(label => { label.targetY = cy - Math.sin(label.angle) * (radius + 28); });
    // Spread each side independently so small slices keep readable, non-overlapping callouts.
    const placed = [false, true].flatMap(right => spreadLabels(labels.filter(label => label.right === right), height));
    const gap = width < 600 ? 18 : 40;
    return {cx, cy, radius, height, labels: placed.sort((a, b) => a.index - b.index).map(label => ({...label,
        x: cx + (label.right ? 1 : -1) * (radius + gap),
        edgeX: cx + Math.cos(label.angle) * radius, edgeY: cy - Math.sin(label.angle) * radius,
        textWidth: Math.max(24, cx - radius - gap - 20),
    }))};
}

export function pieNameLines(name, width, compact) {
    const max = Math.max(4, Math.floor(width / (compact ? 6 : 7)));
    const characters = Array.from(name);
    if (characters.length <= max) return [name];
    const firstBreak = characters.slice(0, max + 1).lastIndexOf(" ");
    const split = firstBreak > max / 2 ? firstBreak : max;
    const remaining = Array.from(characters.slice(split).join("").trim());
    return [characters.slice(0, split).join(""), remaining.length > max ? `${remaining.slice(0, max - 1).join("")}…` : remaining.join("")];
}
